export default __webpack_public_path__ + "static/media/cyn.3053e2de.jpg";